<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCard
            color="danger"
            text-color="white"
            class="text-center py-5 d-md-down-none w-100"
            body-wrapper
            v-show="NoRights"
          >
            <CCardBody>
              <h2>Ei käyttöoikeuksia</h2>
              <p>
                Käyttöoikeuden saamiseksi sinun tulee olla yhteydessä seurasi
                ylläpitäjään.
              </p>
            </CCardBody>
          </CCard>
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody class="position-relative">
                <CForm>
                  <h1>Kirjaudu sisään</h1>
                  <div
                    v-show="LoginError"
                    class="alert alert-danger"
                    role="alert"
                  >
                    {{ ErrorMessage }}
                  </div>
                  <CInput
                    placeholder="Käyttäjätunnus"
                    v-model="UserName"
                    v-on:keyup.enter="Login"
                    :disabled="Loading"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-user"
                    /></template>
                  </CInput>
                  <CInput
                    placeholder="Salasana"
                    type="password"
                    v-model="Password"
                    v-on:keyup.enter="Login"
                    :disabled="Loading"
                  >
                    <template #prepend-content
                      ><CIcon name="cil-lock-locked"
                    /></template>
                  </CInput>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton
                        color="primary"
                        class="px-4"
                        @click="Login"
                        :disabled="Loading"
                        ><CSpinner
                          v-show="Loading"
                          color="secondary"
                          size="sm"
                          class="mr-2"
                        /><span v-show="Loading">Kirjaudutaan</span
                        ><span v-show="!Loading">Kirjaudu</span></CButton
                      >
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import api from "@/utils/api";
import values from "lodash/values";
export default {
  name: "KirjauduSisaan",
  data() {
    return {
      UserName: null,
      Password: null,
      LoginError: false,
      ErrorMessage: null,
      NoRights: false,
      Loading: false
    };
  },
  methods: {
    ForgotPassword() {
      window.location.href =
        "https://visithennala.fi/rymzzakqlzk8mpraqzddu6v7/?action=lostpassword";
    },
    Login: async function() {
      try {
        if (this.UserName && this.Password) {
          this.Loading = true;
          let LoginStatus = await api.post(
            "jwt-auth/v1/token?username=" +
              encodeURIComponent(this.UserName) +
              "&password=" +
              encodeURIComponent(this.Password),
            {
              username: this.UserName,
              password: this.Password
            }
          );
          if (!LoginStatus.success) {
            this.LoginError = true;
            this.ErrorMessage = LoginStatus.message;
            this.Loading = false;
            return;
          }

          let AuthorizationData = {
            idToken: LoginStatus.data.token,
            Email: LoginStatus.data.email
          };

          this.$store.commit("setAuthorizationData", AuthorizationData);

          let Roles = await api.get(
            process.env.VUE_APP_UPSEERIKERHO_API_URL +
              "/roles/" +
              LoginStatus.data.email
          );

          if (typeof Roles !== "object") {
            this.NoRights = true;
            this.Loading = false;
            this.$store.commit("logout");
            return;
          }

          let RoleValues = values(Roles);
          let AdminRoles = [];

          for (let i = 0; i < RoleValues.length; i++) {
            let Role = RoleValues[i];
            if (Role !== "SubscriptionAdmin") {
              let RoleName = await api.get(
                process.env.VUE_APP_UPSEERIKERHO_API_URL + "/role/" + Role
              );
              if (typeof RoleName === "string") {
                AdminRoles.push({
                  Id: Role,
                  Name: RoleName,
                  NameCleaned: RoleName.replace(/ /g, "")
                });
              }
            } else {
              AdminRoles.push({
                Id: process.env.VUE_APP_SUBSCRIPTIONADMINID,
                Name: process.env.VUE_APP_SUBSCRIPTIONADMINNAME,
                NameCleaned: process.env.VUE_APP_SUBSCRIPTIONADMINNAME.replace(
                  / /g,
                  ""
                )
              });
            }
          }

          this.$store.commit("setAdminRoles", AdminRoles);
          this.UserName = null;
          this.Password = null;
          this.Loading = false;

          if (
            AdminRoles.length === 1 &&
            AdminRoles[0].Id !== process.env.VUE_APP_SUBSCRIPTIONADMINID
          ) {
            this.$router.push("/kayttajat/" + AdminRoles[0].NameCleaned);
            return;
          }

          this.$router.push("/");
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>
